import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'Components/Button';
import Card from 'Components/Card';
import ControllerTextArea from 'Components/ControllerTextArea';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { CierreExpedienteSchema } from 'Services/yup/form';

const CerrarSolicitudModal = (props) => {
  const { changeState, actionOK, title } = props;
  const [loader, setLoader] = useState(false);
  const [message, setMessage] = useState('');
  const [confirm, setConfirm] = useState(false);

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset
  } = useForm({
    defaultValues: {
      observaciones: ''
    },
    resolver: yupResolver(CierreExpedienteSchema)
  });

  const submit = async (data) => {
    actionOK(data, setLoader, close);
  };

  const askConfirm = () => {
    setConfirm(true);
  };

  const close = () => {
    setMessage('');
    reset();
    setConfirm(false);
    changeState(false);
  };

  return (
    <Card>
      <button
        type="button"
        className="absolute top-3 end-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
        data-modal-hide="popup-modal"
        onClick={() => close()}>
        <FontAwesomeIcon icon={['fa', 'close']} size="2x" />
      </button>
      {confirm ? (
        <div className="text-center bg-gray-100">
          <FontAwesomeIcon
            icon={['fa', 'triangle-exclamation']}
            size="3x"
            className="text-yellow-300"
          />
          <h3 className="text-lg font-normal m-2">{'¿Esta seguro de eliminar el registro?'}</h3>
          <div className="m-5">
            <ControllerTextArea
              control={control}
              name="observaciones"
              placeholder="Observaciones"
              error={errors?.observaciones}
            />
          </div>
          {message ? <div className="m-5 text-red-400">{message}</div> : ''}
          <Button label="Confirmar" color="error" onClick={handleSubmit(submit)} loading={loader} />
          <Button label="Cancelar" onClick={() => close()} />
        </div>
      ) : (
        <div className="text-center bg-gray-100">
          <FontAwesomeIcon
            icon={['fa', 'triangle-exclamation']}
            size="3x"
            className="text-yellow-300"
          />
          <h3 className="text-lg font-normal m-2">{title}</h3>
          <div className="m-5">
            <ControllerTextArea
              control={control}
              name="observaciones"
              placeholder="Observaciones"
              error={errors?.observaciones}
            />
          </div>
          {message ? <div className="m-5 text-red-400">{message}</div> : ''}
          <Button
            label="Eliminar"
            color="error"
            onClick={handleSubmit(askConfirm)}
            loading={loader}
          />
          <Button label="Cancelar" onClick={() => close()} />
        </div>
      )}
    </Card>
  );
};

CerrarSolicitudModal.propTypes = {
  show: PropTypes.bool,
  changeState: PropTypes.func,
  actionOK: PropTypes.func,
  stateModal: PropTypes.string,
  title: PropTypes.string,
  params: PropTypes.object,
  id: PropTypes.string
};

export default CerrarSolicitudModal;
